module.exports = __webpack_public_path__ + "static/media/backend_large_banner.b191be24.jpg";